const initialState = {};

const visibilityFilter = (state = initialState, action) => {
  switch (action.type) {
    case 'foo': {
      return state;
    }
    default: {
      return state;
    }
  }
};

export default visibilityFilter;
